import React from 'react';
import {
  Banner, Button, Text, Wrapper
} from 'components';
import { Grid } from '@material-ui/core';
import { ROUTES } from 'utils/constants';
import { Link } from 'react-router-dom';
import { translate } from 'utils/translation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/pro-regular-svg-icons';

export const ClimEco = () => (
  <>
    <Banner backgroundImage={`${process.env.PUBLIC_URL}/assets/images/bg/clim_eco_bg.png`}>
      <Text as="h1">
        <strong>{'Bienvenue '}</strong>
        sur la plateforme
        <br />
        {' d\'accès aux ressources'}
        <br />
        documentaires de
        <strong>{' l\'AFF'}</strong>
      </Text>

      <Link to={ROUTES.CATALOG}>
        <Button margin="2rem 0 0 0" startIcon={<FontAwesomeIcon icon={faBook} />}>{translate('button.exploreCatalog')}</Button>
      </Link>
    </Banner>
    <Wrapper>
      <Text as="h2" margin="4rem 0 2rem 0" textAlign="center">
        {translate('pageHome.climEco.title')}
      </Text>

      <Text as="h3" margin="0 0 2rem 0" textAlign="center">
        {translate('pageHome.climEco.subTitle')}
      </Text>

      <Grid container spacing={3} style={{ textAlign: 'justify' }}>
        <Grid item>
          {translate('pageHome.climEco.description')}
        </Grid>
        <Grid item>
          <Text as="h4">
            {translate('pageHome.climEco.onlineFormation')}
          </Text>
        </Grid>
      </Grid>
    </Wrapper>
  </>
);